import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';

import {
  PaginateAlertEmailLogsActions as Actions,
  PaginateAlertEmailLogsRequestAction,
} from 'store/ducks/alertEmailLogs';

export function* paginateAlertEmailLogsRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: PaginateAlertEmailLogsRequestAction = action;

  try {
    const url = applyQueryString('alert-email-log', {
      ...query,
    });

    const { data } = yield call(api.get, url);

    yield put(Actions.success(data.data, data.meta));

    onSuccess && onSuccess();
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);

    yield put(Actions.failure(errorMessage));

    onFailure && onFailure();
    notify('error', errorMessage);
  }
}